
import { defineComponent } from 'vue'
import { useTransactionsHistoryStore } from '@/store/transactions/history.store'

export default defineComponent({
  name: 'ExportTransaction',
  setup() {
    const historyStore = useTransactionsHistoryStore()
    return {
      historyStore
    }
  }
})
